import React, {Component} from 'react';

import Img from 'react-image';

import Loader from '../../display/Loader';

class LazyImage extends Component {
    render() {
        return (
            <Img
                className={this.props.className}
                src={this.props.src}
                style={this.props.style}
                width={this.props.width || "100%"}
                loader={<Loader spin isLoading/>}
            />
        )
    }
}

export default LazyImage;


// WEBPACK FOOTER //
// ./src/components/media/images/LazyImage.js